import React from "react";
import "./timeline.css";
import { configShop } from '../../states/configShop';

const IconCheck = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconFlame = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2c0 6-6 8-6 13a6 6 0 0012 0c0-5-6-7-6-13z" />
    <path d="M12 12c0 3-2 4-2 6a2 2 0 004 0c0-2-2-3-2-6z" />
  </svg>
);

const IconBike = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5.5" cy="17.5" r="3.5" />
    <circle cx="18.5" cy="17.5" r="3.5" />
    <path d="M15 6h-3l-3 11.5" />
    <path d="M9 6l4.5 6H18.5" />
    <path d="M6 10l3-4" />
  </svg>
);

const IconStar = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const IconStore = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l1-5h16l1 5" />
    <path d="M3 9a2 2 0 004 0 2 2 0 004 0 2 2 0 004 0 2 2 0 004 0" />
    <rect x="5" y="13" width="14" height="8" rx="1" />
  </svg>
);

const deliverySteps = [
  { label: "Aceptado",  Icon: IconCheck, value: 1 },
  { label: "En cocina", Icon: IconFlame, value: 5 },
  { label: "En camino", Icon: IconBike,  value: 7 },
  { label: "Entregado", Icon: IconStar,  value: 9 },
];

// PLZ-325: recoger en tienda no tiene "En camino".
const pickupSteps = [
  { label: "Aceptado",           Icon: IconCheck, value: 1 },
  { label: "En preparación",     Icon: IconFlame, value: 5 },
  { label: "Listo para recoger", Icon: IconStore, value: 6 },
  { label: "Recogido",           Icon: IconStar,  value: 9 },
];

export default function OrderTimeline({ currentStep, pickup = false }) {
  const steps = pickup ? pickupSteps : deliverySteps;
  const { dataConfig } = configShop();
  const brand = dataConfig?.page_menu?.button?.color;

  return (
    <div className="tl-wrap">
      {steps.map((step, i) => {
        const done = currentStep >= step.value;
        const isCurrent = currentStep >= step.value && (i === steps.length - 1 || currentStep < steps[i + 1].value);
        const { Icon } = step;

        return (
          <React.Fragment key={i}>
            <div className="tl-step">
              <div
                className={`tl-circle ${done ? "tl-circle--done" : ""} ${isCurrent ? "tl-circle--current" : ""}`}
                style={done ? { "--brand": brand, "--brand-bg": brand + "22", color: brand } : {}}
              >
                <span className="tl-icon"><Icon size={20} /></span>
                {isCurrent && <span className="tl-pulse" style={{ "--brand": brand }} />}
              </div>
              <span
                className={`tl-label ${done ? "tl-label--done" : ""}`}
                style={done ? { color: brand } : {}}
              >
                {step.label}
              </span>
            </div>

            {i < steps.length - 1 && (
              <div
                className={`tl-line ${currentStep >= steps[i + 1].value ? "tl-line--done" : ""}`}
                style={currentStep >= steps[i + 1].value ? { "--brand": brand } : {}}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
